import { VREditorSubPanel } from './subpanel.js';
import { VRRoomLayoutView } from '../layout-view.js';

export class VREditorLayoutPanel extends VREditorSubPanel {
  constructor (vr, editor) {
    super(vr, editor, {
      id: 'layout',
      name: 'Layout',
      instructions: '',
      preview: true,
      assets: vr.assets.layouts,
      addApplyAssetButton: true,
      addApplyAssetMessage: '',
      assetSelectLabel: 'Layout',
      allowAddAsset: false,
      onAssetSwitch: function (asset) {
        this.triggerAlertModal(asset);
      },
      onAssetChange: function (asset) {
        // const layout = new VRRoomLayoutView({
        //   showPerson: true,
        //   assets: asset.assets
        // });
        // this.preview.empty().append(layout.el);

        // if (this.vr.getCurrentScene()) this.vr.loadLayoutTemplate(asset.assets);
      },
      onCreateAssetItem: function (item, asset) {
        const layout = new VRRoomLayoutView({
          showPerson: true,
          assets: asset.assets
        });
        item.append(layout.el);
      }
    });

    this.showPreview(true);
  }

  initControls () {
    // Yaw
    this.rotationLabel = $('<label style="margin-top:20px">Rotation</label>');
    super.append(this.rotationLabel);

    const rotationSlider = $(
      '<input class="ca-vr_editorpanel-range" type="range" min="0" max="360" value="0"></input>'
    );
    super.append(rotationSlider);

    rotationSlider.on('input', function () {});
  }

  triggerAlertModal (asset) {
    this.editor.alertModal.setSuccessState('warning');
    this.editor.alertModal.setAlertMessage('Are you sure you want to overwrite the existing room with the new layout? This cannot be undone.');
    this.editor.alertModal.setAlertCTAButtons({
      buttonCount: 2,
      buttons: [
        {
          type: 'confirm',
          text: 'Continue',
          onClick: function () {
            this.applyNewLayoutScheme(asset);
          }.bind(this)
        },
        {
          type: 'decline',
          text: 'Cancel'
        }
      ]
    });
    this.editor.alertModal.show();
  }

  applyNewLayoutScheme (asset) {
    console.log('apply new layout scheme called');
    const layout = new VRRoomLayoutView({
      showPerson: true,
      assets: asset.assets
    });
    this.preview.empty().append(layout.el);

    if (this.vr.getCurrentScene()) this.vr.loadLayoutTemplate(asset.assets);
  }

  // override
  openPanel(){}
}
